/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Hundred_Percent_Of_PeriodInputs */



/**
* | output |
* | --- |
* | "100% of the period" |
*
* @param {Dashboard_Hundred_Percent_Of_PeriodInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_hundred_percent_of_period = /** @type {((inputs?: Dashboard_Hundred_Percent_Of_PeriodInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Hundred_Percent_Of_PeriodInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("100% des Zeitraums")
	return /** @type {LocalizedString} */ ("100% of the period")
});